import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
export default {
  components: {
    NoData: NoData
  },
  data: function data() {
    return {
      sql: {
        systemId: '',
        sql: ''
      },
      activeName: 'first',
      pageSize: 10,
      pageNum: 1,
      tableData: [],
      total: 0,
      columnList: [],
      dataList: [],
      systemList: [],
      tableheight: '600px',
      info: ''
    };
  },
  created: function created() {
    var _this = this;
    this.$API.getRequest({
      url: '/platform/systemInner/list'
    }).then(function (res) {
      if (res.code === '0000000000') {
        res.result.records.forEach(function (ele) {
          _this.systemList.push({
            systemId: ele.systemId,
            systemName: ele.systemName
          });
        });
      }
    });
  },
  methods: {
    handleClick: function handleClick() {},
    submit: function submit() {
      var _this2 = this;
      this.$API.postRequest({
        url: '/platform/sql',
        data: {
          systemId: this.sql.systemId,
          sql: this.sql.sql,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          if (res.result.dataSize == null) {
            _this2.activeName = 'second';
            _this2.columnList = res.result.columnList;
            _this2.dataList = res.result.data;
            _this2.total = res.result.total;
          } else {
            _this2.info = res.result.dataSize;
          }
        }
      });
    }
  }
};